var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fieldset"},[_c('label',[_vm._v("銷售員工工號")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.id),expression:"id"}],attrs:{"maxlength":"10","autocomplete":"off","type":"text"},domProps:{"value":(_vm.id)},on:{"input":function($event){if($event.target.composing)return;_vm.id=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }